import {connect} from '@modifi/redux'
import {
  selectAuthenticationUserFirstName,
  selectAuthenticationCompanyName,
  selectAuthenticationUserLastName,
} from '@modifi/plugin-authentication'
import {
  selectHasCreatedTrades,
  selectIsOrderCreationDisabled,
  selectIsReportsEnabled,
  selectUserActions,
} from '@modifi/plugin-trade'

import Navigation, {NavigationProps} from './Navigation'

const mapStateToProps = (
  state: Record<string, any>
): Pick<
  NavigationProps,
  | 'userFirstName'
  | 'userLastName'
  | 'companyName'
  | 'hasCreatedTrades'
  | 'isOrderCreationDisabled'
  | 'userActions'
  | 'isReportsEnabled'
> => ({
  userFirstName: selectAuthenticationUserFirstName(state),
  userLastName: selectAuthenticationUserLastName(state),
  companyName: selectAuthenticationCompanyName(state),
  hasCreatedTrades: selectHasCreatedTrades(state),
  isOrderCreationDisabled: selectIsOrderCreationDisabled(state),
  userActions: selectUserActions(state),
  isReportsEnabled: selectIsReportsEnabled(state),
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Navigation)
